import React from 'react';

interface ActionRowProps {
  children: React.ReactNode;
  className?: string;
}

export const ActionRow: React.FC<ActionRowProps> = ({ children, className = '' }) => {
  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end ${className}`.trim()}>
      {children}
    </div>
  );
};
